import { handleActions }   from 'redux-actions';
import { combineReducers } from 'redux-immutable';
import {
  clear,
  updateOrgEmail,
  updateOrgName,
  updateOrgPhone,
  updateUserEmail,
  updateUserFamilyName,
  updateUserGivenName,
}                          from '../../actions/registration/serviceProvider';

const orgName = handleActions(
  {
    /**
     * Resets the registration form
     *
     * @return string
     */
    [clear]() {

      return '';

    },

    [updateOrgName](state, {payload: {orgName}}) {

      return orgName;

    }


  },

  ''
);

const orgPhone = handleActions(
  {
    /**
     * Resets the registration form
     *
     * @return string
     */
    [clear]() {

      return '';

    },

    [updateOrgPhone](state, {payload: {orgPhone}}) {

      return orgPhone;

    }


  },

  ''
);

const orgEmail = handleActions(
  {
    /**
     * Resets the registration form
     *
     * @return string
     */
    [clear]() {

      return '';

    },

    [updateOrgEmail](state, {payload: {orgEmail}}) {

      return orgEmail;

    }


  },

  ''
);

const userEmail = handleActions(
  {
    /**
     * Resets the registration form
     *
     * @return string
     */
    [clear]() {

      return '';

    },

    [updateUserEmail](state, {payload: {userEmail}}) {

      return userEmail;

    }


  },

  ''
);

const userGivenName = handleActions(
  {
    /**
     * Resets the registration form
     *
     * @return string
     */
    [clear]() {

      return '';

    },

    [updateUserGivenName](state, {payload: {userGivenName}}) {

      return userGivenName;

    }


  },

  ''
);

const userFamilyName = handleActions(
  {
    /**
     * Resets the registration form
     *
     * @return string
     */
    [clear]() {

      return '';

    },

    [updateUserFamilyName](state, {payload: {userFamilyName}}) {

      return userFamilyName;

    }


  },

  ''
);

export default combineReducers({orgName, orgPhone, orgEmail, userEmail, userGivenName, userFamilyName});


// WEBPACK FOOTER //
// ./src/reducers/registration/serviceProvider.js